// The race's rules and the questions players ask, in one fold-out. Every
// answer here is what the code does and was tested (2026-10-21).
import React from 'react';
import './RaceRules.css';

const RULES = [
  'Everyone in the room gets the same character, the same size and exactly the same pieces.',
  'Your clock is yours: it starts when your pieces break apart and stops at the last piece. Want one start for all? Press "Start together".',
  'Fastest finished time wins. Not finished yet? You rank by pieces joined.',
  'Race again as often as you like. Only your best time counts.',
  'Everyone sees your progress each time you join a piece.',
];

const FAQ = [
  ['Can we all start at the same second?', 'Yes. When everyone is on the picture, anyone presses "Start together": a 10-second countdown runs on every phone and all the pieces break apart at once. Or just press Start game whenever you like — each clock is personal.'],
  ['I joined after they started together.', 'You start the moment you press Start race, with a note saying how long ago the others began. Your clock is still yours, so a late start costs you nothing.'],
  ['How do I see who is ahead?', 'The track under the clock: one lane per racer, and their ship moves with every piece they join. It shows this round only.'],
  ['Where are all my times?', 'Tap your name in the room: every finished run is listed, and your best is marked. Only the best counts in the room.'],
  ['I refreshed, or my phone locked.', 'Your race is kept. Open the puzzle again and carry on. The clock kept running, so come back quickly.'],
  ['My connection dropped at the end.', 'Your time waits on your phone and is sent the moment you are back online.'],
  ['Do I need an account?', 'No. A name is enough. With an account your name fills in by itself and your rooms show on your profile.'],
  ['Someone took my name.', 'One name per player in a room. If it is taken on another phone, pick a different one.'],
  ['How many can race?', 'As many as you like. Eight players racing at once was tested with no slowdown.'],
  ['Who runs the room?', 'Whoever made it (👑). They can remove a player or close the room. Nothing is deleted, and both can be undone.'],
  ['Can someone fake a time?', 'Impossibly fast times are refused by the server.'],
];

export default function RaceRules({ className = '' }) {
  return (
    <details className={`race-rules ${className}`}>
      <summary>How the race works</summary>
      <ol className="race-rules-list">
        {RULES.map((r) => <li key={r}>{r}</li>)}
      </ol>
      <div className="race-faq">
        {FAQ.map(([q, a]) => (
          <div key={q} className="race-faq-item">
            <strong>{q}</strong>
            <span>{a}</span>
          </div>
        ))}
      </div>
    </details>
  );
}
